
export const DEF_APPNAME = 'appname'


/****************** */

export const CM_SC_HOME = ''
export const CM_SC_LOGIN = 'login'

/* 23.12.05 CM_SC_TOWN_SAC 추가 townMain -> town 수정 */
// export const CM_SC_TOWN='townMain';
export const CM_SC_TOWN = 'town'
export const CM_SC_TOWN_SAC = 'town/profiles'

export const CM_SC_PROFILES = 'profiles'
export const CM_SC_SALES = 'sales'
export const CM_SC_SETTLE = 'settle'
export const CM_SC_SALES_SAC = 'sales_sac'
export const CM_SC_SETTLE_SAC = 'settle_sac'

export const CM_SC_WASHPODMODEL = 'washPod/washPodModel'
export const CM_SC_WASHPODMODEL_DETAIL = 'washPod/washPodModel/detail'
export const CM_SC_WASHPODMODEL_WRITE = 'washPod/washPodModel/write'
export const CM_SC_WASHPOD = 'washPod/washPod'
export const CM_SC_WASHPOD_DETAIL = 'washPod/washPod/detail'
export const CM_SC_COUPON = 'coupon'
export const CM_SC_COUPON_DETAIL = 'coupon/detail'
export const CM_SC_COUPON_MODEL = 'cpn_model'
export const CM_SC_COUPON_WRITE = 'coupon/write'
export const CM_SC_COUPON_UPDATE = 'coupon/update'

export const CM_SC_DISCOUNT_CPN = 'discount'
export const CM_SC_DISCOUNT_CPN_USAGE = 'discount-usage'

export const CM_SC_CREDIT_CPN = 'credit'
export const CM_SC_CREDIT_CPN_USAGE = 'credit-usage'


export const CM_SC_COURSE = 'course'
export const CM_SC_COURSE_DETAIL = 'course/detail'
export const CM_SC_COURSE_WRITE = 'course/write'
export const CM_SC_COURSE_UPDATE = 'course/update'

export const CM_SC_WASHOPT = 'washOpt'
export const CM_SC_WASHOPT_DETAIL = 'washOpt/detail'
export const CM_SC_WASHOPT_WRITE = 'washOpt/write'
export const CM_SC_WASHOPT_UPDATE = 'washOpt/update'

export const CM_SC_REVIEWS = 'reviews'
export const CM_SC_NOTIES = 'notis'
export const CM_SC_REVIEW_REPORT = 'review-report'
export const CM_SC_REVIEW_REPORT_DETAIL = 'review-report/detail'

export const CM_SC_ALARM = 'alarm'

export const CM_SC_DATA = 'data'

export const CM_SC_CUSTOMER = 'user/customer'
export const CM_SC_CUSTOMER_DETAIL = 'customer/detail'
export const CM_SC_PARTNER = 'user/partner'
export const CM_SC_ADMIN = 'user/admin'
export const CM_SC_PARTNER_USER = 'user/partner/user'
export const CM_SC_CAR = 'user/car'
export const CM_SC_BANNER = 'banner'

export const CM_SC_FAQ = 'faq'
export const CM_SC_FAQ_WRITE = 'faq/write'
export const CM_SC_REPORT_SALES = 'report/sales'
export const CM_SC_REPORT_SALES_SAC = 'report/sales/sac'


export const CM_TEST = 'test'

/** 쿠폰관리 */
export const CM_DISCOUNT_COUPON = 'discount'


/** 쿠폰 사용 내역 */
export const CM_DISCOUNT_COUPON_USAGE = 'discount-usage'
/** 외상 관리 */
export const CM_CREDIT = 'credit'
export const CM_CREDIT_USAGE = 'credit-usage'



